import Plot from "react-plotly.js";
import { DEFAULT_PLOTLY_CONFIG } from "src/constants/constants";
import { FILE_TYPE_COLORS, FILE_TYPE_LABELS } from "../adminReportUtils";
import { FileType } from "../types";

const CHART_CONFIG = { ...DEFAULT_PLOTLY_CONFIG, displayModeBar: false };

interface FileTypeDistributionChartProps {
  totals: { fileType: FileType; count: number }[];
}

const FileTypeDistributionChart = ({
  totals,
}: FileTypeDistributionChartProps) => {
  const data: any = [
    {
      type: "pie",
      hole: 0.62,
      sort: false,
      labels: totals.map(({ fileType }) => FILE_TYPE_LABELS[fileType]),
      values: totals.map(({ count }) => count),
      marker: {
        colors: totals.map(({ fileType }) => FILE_TYPE_COLORS[fileType]),
        line: { color: "#ffffff", width: 2 },
      },
      textinfo: "none",
      hovertemplate: "%{label}: %{value} (%{percent})<extra></extra>",
    },
  ];

  const layout: any = {
    height: 220,
    margin: { t: 8, r: 8, b: 8, l: 8 },
    showlegend: false,
    paper_bgcolor: "transparent",
    plot_bgcolor: "transparent",
  };

  return (
    <Plot
      className="admin-report__chart"
      data={data}
      layout={layout}
      config={CHART_CONFIG}
      useResizeHandler
      style={{ width: "100%" }}
    />
  );
};

export default FileTypeDistributionChart;
